
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function StudentElbow(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Student elbow (Olecranon Bursitis)"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Student's elbow is a condition where a small sack of tissue over the
                                    tip of your elbow becomes inflamed and swollen. The pointy bit of
                                    bone at the end of your elbow is called the 'olecranon' and the
                                    small sack which sits between the bone and the skin is called a
                                    'bursa'.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Student-elbow(Olecranon-Bursitis)/1.png")} alt="Student-elbow(Olecranon-Bursitis)" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p><b>Elbow (olecranon) bursitis is characterized by:</b></p>
                                <p><b>Swelling: </b>
                                    The initial symptom of olecranon bursitis is often swelling that develops at the back of the
                                    elbow.</p>

                                <p><b>Pain: </b>
                                    Pain most often occurs with direct pressure on the elbow, such as when resting the elbow
                                    on a hard surface. Pain can sometimes occur with bending the elbow. Some people may only
                                    experience swelling without significant pain.</p>
                                <p><b>Redness and/or warmth: </b>
                                    Occasionally, the olecranon bursa can become infected. Typical
                                    symptoms of an infected olecranon bursa include the skin becoming warm and red. A person
                                    may also develop a fever associated with an infected olecranon bursa.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Olecranon_bursitis">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default StudentElbow;